import type { AxiosResponse } from "axios";

import { getData, postData } from "@/apis/apiInstance";

import type {
  GetAllClientSchedulingListPayloadType,
  GetAllUsersSchedulingListPayloadType,
  GetClientJobSchedulingListPayloadType,
  GetClientUserSchedulingListPayloadType,
  GetRequestIdPayloadType,
  GetScheduledAllUserMappedToJobPayloadType,
  GetScheduledJobsHourPayloadType,
  GetSchedulingUserPayloadType,
  GetUserAvailabilityReportPayloadType,
  RevokeSchedulingEstimatePayloadType,
} from "@/commonTypes/schedulingTypes";

import { formatDate, getCSRFToken } from "@/utils/commonFunctions";

export async function getSchedulingUserViewListApi(
  data: GetSchedulingUserPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    clientCode,
    typeOfJob,
    searchData,
    limit,
    offset,
    isApproved,
    sortByStartDate,
    filterTargetStartDate,
    filterTargetEndDate,
    filterStartDate,
    filterStartDateTo,
    filterStatus,
    userId,
  } = data;
  return await getData(`/finac-crm/scheduling/employee/list`, {
    params: {
      search_term: searchData,
      client_code: clientCode,
      type_of_job: typeOfJob,
      is_approved: isApproved,
      sort_by: sortByStartDate?.sort_by,
      sort_by_value: sortByStartDate?.sort_by_value,
      target_end_date_from: filterTargetStartDate,
      target_end_date_to: filterTargetEndDate,
      target_start_date_from: filterStartDate,
      target_start_date_to: filterStartDateTo,
      schedule_status: filterStatus,
      limit,
      offset,
      user_id: userId,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSchedulingBandWidthApi(
  data: any
): Promise<AxiosResponse> {
  const { token, date, user_id, request_id } = data;
  return await getData(`finac-crm/scheduling/bandwidth`, {
    params: {
      user_id,
      date: date,
      ...(request_id && { request_id }),
      // client_code:clientCode,
      // type_of_job:typeOfJob,
      // limit,
      // offset
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//
export async function getSchedulingEmployeeApprovedListApi(
  data: any
): Promise<AxiosResponse> {
  // const { token , date} = data;
  const { token, clientCode, typeOfJob, limit, offset } = data;

  return await getData(`/finac-crm/scheduling/employee/list/approved`, {
    params: {
      client_code: clientCode,
      type_of_job: typeOfJob,
      limit,
      offset,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
// comment
export async function getSchedulingCommentListApi(
  data: any
): Promise<AxiosResponse> {
  // const { token , date} = data;
  const { token, requestId } = data;

  return await getData(`/finac-crm/scheduling/comment/list`, {
    params: {
      request_id: requestId,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//  add comment

export async function AddSchedulingCommentApi(
  data: any
): Promise<AxiosResponse> {
  const { token, request_id, comment } = data;

  return await postData(
    `/finac-crm/scheduling/add-comment`,
    { request_id, comment },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
//
export async function AddSchedulingEstimateApi(
  data: any
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    manager_id,
    job_id,
    future_job_id,
    user_id,
    estimate,
    estimation_type,
    estimation_start_date,
    estimation_end_date,
    shared_job,
  } = data;

  return await postData(
    `/finac-crm/scheduling/request/add`,
    {
      client_code,
      manager_id,
      user_id,
      job_id,
      future_job_id,
      estimate,
      estimation_type,
      estimation_start_date,
      estimation_end_date,
      shared_job,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getManagerViewRequestApi(
  data: any
): Promise<AxiosResponse> {
  const { token, id, isPageSeen, redirectNotificationId } = data;

  return await getData(`finac-crm/scheduling/request`, {
    params: {
      id,
      is_page_seen: isPageSeen,
      notification_id: redirectNotificationId,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getManagerNewRequestListApi(
  data: any
): Promise<AxiosResponse> {
  const {
    token,
    clientCode,
    search_term,
    typeOfJob,
    limit,
    offset,
    schedule_status,
    employeeName,
    targetDate,
    approved,
    allSortingValue,
    targetEndDateSortingData,
    userTypeSortingData,
    filterTargetStartDate,
    filterTargetEndDate,
  } = data;
  const employeeNameSortedOrder =
    allSortingValue === "employee_name_desc"
      ? "desc"
      : allSortingValue === "employee_name_asc"
        ? "asc"
        : "";
  const targetDateSortedOrder =
    allSortingValue === "target_date_desc"
      ? "desc"
      : allSortingValue === "target_date_asc"
        ? "asc"
        : "";
  let finalParams = {
    limit,
    offset,
    schedule_status,
    approved,
    client_code: clientCode,
    target_end_date: filterTargetEndDate,
    target_start_date: filterTargetStartDate,
    target_end_date_sorted_order: targetEndDateSortingData
      ? targetEndDateSortingData
      : targetDateSortedOrder,
    user_sorted_order: userTypeSortingData
      ? userTypeSortingData
      : employeeNameSortedOrder,
    ...(search_term && search_term?.length > 0 && { search_term }),
    // ...(employeeName&&)
  };
  return await getData(`finac-crm/scheduling/request/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSchedulingReEstimateListApi(
  data: GetRequestIdPayloadType
): Promise<AxiosResponse> {
  const { token, id, isPageSeen, notificationRedirectId } = data;

  return await getData(`/finac-crm/scheduling/request`, {
    params: {
      id: id,
      is_page_seen: isPageSeen,
      notification_id: notificationRedirectId,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function UpdateSchedulingEstimateApi(
  data: any
): Promise<AxiosResponse> {
  const { request_id, token, schedule_status } = data;
  return await postData(
    `finac-crm/scheduling/request/manager/update-status`,
    {
      request_id,
      schedule_status,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getSchedulingCalendarApi(
  data: any
): Promise<AxiosResponse> {
  const { token, user_id, startDate, endDate, schedule_status } = data;
  let finalParams = {
    user_id,
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
    schedule_status,
  };

  return await getData(`finac-crm/scheduling/calendar/list`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",

      "user-token": token,
    },
  });
}

export async function getAllUsersSchedulingListApi(
  data: GetAllUsersSchedulingListPayloadType
): Promise<AxiosResponse> {
  const { token, startDate, endDate, sortByUserName, scheduleStatus } = data;
  let finalParams = {
    start_date: startDate,
    end_date: endDate,
    user_sorted_order: sortByUserName?.value,
    schedule_status: scheduleStatus,
  };

  return await getData(`finac-crm/scheduling/report`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllClientSchedulingListApi(
  data: GetAllClientSchedulingListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    clientName,
    clientCode,
    filterClientCode,
    userId,
    startDate,
    endDate,
  } = data;
  let finalParams = {
    ...(clientName && { client_name: clientName }),
    ...(clientCode && { client_code: clientCode }),
    ...(userId && { user_id: userId }),
    ...(filterClientCode && { client_code_filter: filterClientCode }),
    ...(startDate && { start_date: startDate }),
    ...(endDate && { end_date: endDate }),
  };

  return await getData(`finac-crm/scheduling/scheduling-reports/client-list`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getClientUserSchedulingListApi(
  data: GetClientUserSchedulingListPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, limit, offset, start_date, end_date } = data;
  let finalParams = {
    start_date,
    client_code,
    limit,
    offset,
    end_date,
  };

  return await getData(`finac-crm/scheduling/client/users/scheduling/report`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getClientJobSchedulingListApi(
  data: GetClientJobSchedulingListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    limit,
    offset,
    start_date,
    end_date,
    target_end_sorted_order,
    job_type_sorted_order,
    job_status_sorted_order,
  } = data;
  let finalParams = {
    start_date,
    client_code,
    limit,
    offset,
    end_date,
    job_type_sorted_order,
    target_end_sorted_order,
    job_status_sorted_order,
  };

  return await getData(`finac-crm/scheduling/client/jobs/scheduling/report`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getScheduledJobsHourApi(
  data: GetScheduledJobsHourPayloadType
): Promise<AxiosResponse> {
  const { token, job_id } = data;
  let finalParams = {
    job_id,
  };

  return await getData(`finac-crm/scheduling/open/jobs/schedule/hours`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getScheduledAllUserMappedToJobApi(
  data: GetScheduledAllUserMappedToJobPayloadType
): Promise<AxiosResponse> {
  const {
    startDate,
    endDate,
    clientCode,
    job,
    token,
    userSortedOrder,
    futureJob,
  } = data;
  let finalParams = {
    start_date: startDate,
    end_date: endDate,
    client_code: clientCode,
    job,
    user_sorted_order: userSortedOrder,
    future_job: futureJob,
  };

  return await getData(`finac-crm/scheduling/client-job/user/report`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// availability report

export async function getUserAvailabilityReportApi(
  data: GetUserAvailabilityReportPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    startDate,
    endDate,
    sortByUserName,
    workingDays,
    limit,
    offset,
    userId,
    departmentId,
  } = data;
  let finalParams = {
    start_date: startDate,
    end_date: endDate,
    user_sorted_order: sortByUserName?.value,
    working_days: workingDays,
    limit,
    offset,
    user_id: userId,
    department_id: departmentId,
  };

  return await getData(`finac-crm/scheduling/free-user/report`, {
    params: {
      ...finalParams,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function revokeSchedulingRequestApi(
  data: RevokeSchedulingEstimatePayloadType
): Promise<AxiosResponse> {
  const { token, requestId } = data;
  return await postData(
    `/finac-crm/scheduling/request/revoke`,
    { request_id: requestId },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
